// // import NtxPeoples2 from '../../../NTX/Peoples/NtxPeoples'
// import Select from 'react-select';

// import { Form } from 'react-bootstrap';
// // import NtxPeoples from '../../../NTX/Peoples/NtxPeoples3';
// import { useFormik } from 'formik';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { useTranslation } from 'react-i18next';
// import {
//   AddNtxPeoples,
//   cleanPeoplesById,
//   GetNtxPeoplesByID,
//   GetNtxPeoplesList,
//   UpdatNtxPeoples
// } from '@store/NTX/Peoples/peoplesSlice';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import useGetPersons from '@hooks/HR/use-get-persons';
// import useGetFormColumn from '@hooks/Forms/use-get-FColumn';
// import ExtraInformationBuilderAdd from '@pages/ExtraInformation/ExtraInformationBuilder/Add/ExtraInformationBuilderAdd';
// import { useEffect, useState } from 'react';
// import useAddUpdateExtraInformation from '@pages/ExtraInformation/ExtraInformationBuilder/useAddUpdateExtraInformation';
// import ExtraInformationBuilderUpdate from '@pages/ExtraInformation/ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';
// import Loading from '@components/Shared/Loader/Loading';

// type Props = {
//   Id?: string | null;
//   isUpdate?: boolean;
// };

// const AddDriver: React.FC<Props> = ({ Id, isUpdate = false }) => {
//   const [extraInfoFormData, setExtraInfoFormData] = useState<any>({});

//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const { dataEmployees, loading: personLoading, error: personError } = useGetPersons();

//   const { AddUpdateExtraInformation } = useAddUpdateExtraInformation();

//   useEffect(() => {
//     if (Id && isUpdate) {
//       dispatch(GetNtxPeoplesByID(Id));
//     }

//     return () => {
//       dispatch(cleanPeoplesById());
//     };
//   }, [Id, dispatch, isUpdate]);

//   const { PeoplesById, loading: loading, error } = useAppSelector(state => state.Peoples);

//   const formik = useFormik({
//     initialValues: {
//       id: PeoplesById?.id ?? null,
//       name: PeoplesById?.name ?? '',
//       name2: PeoplesById?.name2 ?? '',
//       personId: PeoplesById?.personId ?? null,
//       typeCode: 'DRIVERS',
//       email: PeoplesById?.email ?? '',
//       phone: PeoplesById?.phone ?? '',
//       mobile: PeoplesById?.mobile ?? '',
//       address: PeoplesById?.address ?? '',
//       extraInformationId: PeoplesById?.extraInformationId ?? null
//     },
//     enableReinitialize: true,
//     // validationSchema: NtxPeopleSchema(t),

//     // onSubmit: async values => {
//     //   const requestBody = {
//     //     id: values.id,
//     //     name: values.name,
//     //     name2: values.name2,
//     //     personId: values.personId || null,
//     //     email: values.email,
//     //     phone: values.phone,
//     //     // fax: values.fax,
//     //     mobile: values.mobile,
//     //     address: values.address,
//     //     typeCode: values.typeCode,
//     //     customerNumber: '',
//     //     parentId: null,
//     //     extraInformationId: extraInformationId,
//     //     priceListId: null,
//     //     shipToLocationId: null,
//     //     billToLocationId: null,
//     //     termsId: null,
//     //     setOfBooksId: null,
//     //     creditLimit: 0,
//     //     paymentPriority: null,
//     //     invoiceCurrencyCode: null,
//     //     paymentCurrencyCode: null,
//     //     invoiceLimit: null,
//     //     paymentMethodLookupCode: '',
//     //     bankAccountName: '',
//     //     bankAccountNum: '',
//     //     bankNumber: '',
//     //     bankAccountType: '',
//     //     vatCode: 0,
//     //     tradingName: '',
//     //     workReference: '',
//     //     companyRegistrationNumber: '',
//     //     nationalInsuranceNumber: '',
//     //     verificationNumber: '',
//     //     description: '',
//     //     // description: values.description,
//     //     // integrationField: null
//     //     // peopleType: values.peopleType,
//     //     peopleType: ''
//     //     // peopleCategory: values.peopleCategory,
//     //     // accountId: values.accountId || null,
//     //     // prepaymentAccountId: values.prepaymentAccountId ?? null
//     //     //
//     //   };

//     //   debugger;
//     //   if (!isUpdate || (isUpdate && values.extraInformationId === null)) {
//     //     var extraInformationId;
//     //     if (FormColumnList?.columnList?.length > 0) {
//     //       extraInformationId = await AddUpdateExtraInformation(extraInfoFormData);
//     //     }
//     //     if (FormColumnList?.columnList?.length > 0 && extraInformationId === null) {
//     //       CustomAlert({ action: 'Error', msg: 'حدث خطأ' });
//     //       return;
//     //     }

//     //     const actionToDispatch = isUpdate
//     //       ? UpdatNtxPeoples({
//     //           ...requestBody,
//     //           ...(extraInformationId ? { extraInformationId } : {})
//     //         })
//     //       : AddNtxPeoples(requestBody);

//     //     dispatch(actionToDispatch)
//     //       .unwrap()
//     //       .then(res => {
//     //         if (res?.succeeded === true) {
//     //           if (isUpdate) {
//     //             CustomAlert({ action: 'Edit' });
//     //             dispatch(GetNtxPeoplesList('DRIVERS'));
//     //           } else {
//     //             document.getElementById('closeModalForm')?.click();
//     //             formik.resetForm();
//     //             dispatch(GetNtxPeoplesList('DRIVERS'));
//     //             CustomAlert({ action: 'Add' });
//     //           }
//     //         } else {
//     //           formik.setSubmitting(false);
//     //           CustomAlert({ action: 'Error', msg: res?.message });
//     //         }
//     //       })
//     //       .catch(() => {
//     //         formik.setSubmitting(false);
//     //         CustomAlert({ action: 'Error' });
//     //       });
//     //   } else {
//     //     let respons: any;
//     //     if (extraInfoFormData?.values?.length > 0) {
//     //       respons = await AddUpdateExtraInformation(extraInfoFormData);
//     //     }
//     //     // debugger;
//     //     if (respons === null) {
//     //       CustomAlert({ action: 'Error' });
//     //       return;
//     //     }
//     //     // formData.append('ExtraInformationId', respons || '');

//     //     const actionToDispatch = UpdatNtxPeoples({ ...requestBody, extraInformationId: respons || '' });

//     //     dispatch(actionToDispatch)
//     //       .unwrap()
//     //       .then(res => {
//     //         if (res?.succeeded === true) {
//     //           if (isUpdate) {
//     //             CustomAlert({ action: 'Edit' });
//     //             dispatch(GetNtxPeoplesList('DRIVERS'));
//     //           } else {
//     //             document.getElementById('closeModalForm')?.click();
//     //             formik.resetForm();
//     //             dispatch(GetNtxPeoplesList('DRIVERS'));
//     //             CustomAlert({ action: 'Add' });
//     //           }
//     //         } else {
//     //           formik.setSubmitting(false);
//     //           CustomAlert({ action: 'Error', msg: res?.message });
//     //         }
//     //       })
//     //       .catch(() => {
//     //         formik.setSubmitting(false);
//     //         CustomAlert({ action: 'Error' });
//     //       });
//     //   }
//     // }

//     onSubmit: async values => {
//       // بناء الـ request body
//       const requestBody: any = {
//         id: values.id,
//         name: values.name,
//         name2: values.name2,
//         personId: values.personId || null,
//         email: values.email,
//         phone: values.phone,
//         mobile: values.mobile,
//         address: values.address,
//         typeCode: values.typeCode,
//         customerNumber: '',
//         parentId: null,
//         extraInformationId: null, // سيتم تحديثه لاحقًا
//         priceListId: null,
//         shipToLocationId: null,
//         billToLocationId: null,
//         termsId: null,
//         setOfBooksId: null,
//         creditLimit: 0,
//         paymentPriority: null,
//         invoiceCurrencyCode: null,
//         paymentCurrencyCode: null,
//         invoiceLimit: null,
//         paymentMethodLookupCode: '',
//         bankAccountName: '',
//         bankAccountNum: '',
//         bankNumber: '',
//         bankAccountType: '',
//         vatCode: 0,
//         tradingName: '',
//         workReference: '',
//         companyRegistrationNumber: '',
//         nationalInsuranceNumber: '',
//         verificationNumber: '',
//         description: '',
//         peopleType: ''
//       };

//       let finalExtraInformationId = values.extraInformationId;

//       // فقط إذا لم يكن موجودًا أو نحتاج لإنشاء واحد جديد
//       // if (!isUpdate || (isUpdate && values.extraInformationId === null)) {
//       if (values.extraInformationId === null) {
//         if (FormColumnList?.columnList?.length > 0) {
//           const newExtraInfoId = await AddUpdateExtraInformation(extraInfoFormData);
//           if (newExtraInfoId === null) {
//             CustomAlert({ action: 'Error', msg: 'حدث خطأ' });
//             formik.setSubmitting(false);
//             return;
//           }
//           finalExtraInformationId = newExtraInfoId;
//         }
//       } else {
//         // حالة التحديث مع وجود extraInfo
//         if (extraInfoFormData?.values?.length > 0) {
//           const updatedExtraInfoId = await AddUpdateExtraInformation(extraInfoFormData);
//           if (updatedExtraInfoId === null) {
//             CustomAlert({ action: 'Error', msg: 'فشل في تحديث المعلومات الإضافية' });
//             formik.setSubmitting(false);
//             return;
//           }
//           finalExtraInformationId = updatedExtraInfoId;
//         }
//       }

//       // دمج الـ extraInformationId في الطلب
//       requestBody.extraInformationId = finalExtraInformationId;

//       // تحديد الإجراء (إضافة أو تعديل)
//       const actionToDispatch = isUpdate ? UpdatNtxPeoples(requestBody) : AddNtxPeoples(requestBody);

//       // تنفيذ الإجراء
//       dispatch(actionToDispatch)
//         .unwrap()
//         .then(res => {
//           if (res?.succeeded === true) {
//             if (isUpdate) {
//               CustomAlert({ action: 'Edit' });
//             } else {
//               document.getElementById('closeModalForm')?.click();
//               formik.resetForm();
//               CustomAlert({ action: 'Add' });
//             }
//             dispatch(GetNtxPeoplesList('DRIVERS'));
//           } else {
//             CustomAlert({ action: 'Error', msg: res?.message || 'حدث خطأ غير معروف' });
//           }
//         })
//         .catch(error => {
//           console.error('Error in dispatch:', error);
//           CustomAlert({ action: 'Error', msg: 'خطأ في الاتصال أو المعالجة' });
//         })
//         .finally(() => {
//           formik.setSubmitting(false);
//         });
//     }
//   });

//   const {
//     FormColumnList,
//     loading: loading2,
//     error: error2
//   } = useGetFormColumn(
//     !isUpdate || (isUpdate && formik.values.extraInformationId === null)
//       ? '04ba71f9-c9b7-4e99-8a03-306a923b3cf0'
//       : undefined
//   );

//   return (
//     <>
//       <Loading loading={personLoading || loading || loading2} error={personError || error || error2}>
//         <Form onSubmit={formik.handleSubmit}>
//           <div className='mb-4'>
//             <>
//               <div className='row'>
//                 <div className='col-xl-4'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('LocalName')}</label>
//                     <Form.Control
//                       className='form-control'
//                       type='text'
//                       autoComplete='off'
//                       name='name2'
//                       onChange={formik.handleChange}
//                       value={formik.values.name2}
//                       isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
//                     />
//                     <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
//                   </div>
//                 </div>

//                 <div className='col-xl-4'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('GlobalName')}</label>
//                     <Form.Control
//                       className='form-control'
//                       type='text'
//                       autoComplete='off'
//                       name='name'
//                       onChange={formik.handleChange}
//                       value={formik.values.name}
//                       isInvalid={!!(formik.touched.name && formik.errors.name)}
//                     />
//                     <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
//                   </div>
//                 </div>

//                 <div className='col-xl-4'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('EmployeeName')}</label>
//                     <Select
//                       classNamePrefix='react-select'
//                       isLoading={personLoading}
//                       isSearchable={true}
//                       isClearable
//                       name='personId'
//                       options={dataEmployees}
//                       onChange={option => {
//                         formik.setFieldValue('personId', option === null ? null : option.value);
//                       }}
//                       value={
//                         formik.values.personId
//                           ? dataEmployees?.find((option: any) => option.value === formik.values.personId)
//                           : null
//                       }
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                       menuPortalTarget={document.body}
//                       styles={{
//                         menuPortal: base => ({ ...base, zIndex: 9999 })
//                       }}
//                     />

//                     {formik.errors.personId && formik.touched.personId && (
//                       <div style={{ color: 'red' }}>{formik.errors.personId}</div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className='row'>
//                 <div className='col-xl-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Email')}</label>
//                     <Form.Control
//                       className='form-control'
//                       type='text'
//                       autoComplete='off'
//                       name='email'
//                       onChange={formik.handleChange}
//                       value={formik.values.email}
//                       isInvalid={!!(formik.touched.email && formik.errors.email)}
//                     />
//                     <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>
//                   </div>
//                 </div>

//                 <div className='col-xl-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('MobileNumber')}</label>
//                     <Form.Control
//                       className='form-control'
//                       type='text'
//                       autoComplete='off'
//                       name='mobile'
//                       onChange={formik.handleChange}
//                       value={formik.values.mobile}
//                       isInvalid={!!(formik.touched.mobile && formik.errors.mobile)}
//                     />
//                     <Form.Control.Feedback type='invalid'>{formik.errors.mobile}</Form.Control.Feedback>
//                   </div>
//                 </div>

//                 <div className='col-xl-6'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Address')}</label>
//                     <Form.Control
//                       className='form-control'
//                       type='text'
//                       autoComplete='off'
//                       name='address'
//                       onChange={formik.handleChange}
//                       value={formik.values.address}
//                       isInvalid={!!(formik.touched.address && formik.errors.address)}
//                     />
//                     <Form.Control.Feedback type='invalid'>{formik.errors.address}</Form.Control.Feedback>
//                   </div>
//                 </div>
//               </div>
//             </>
//           </div>

//           <div className='rounded-2 p-3 mb-3 border border-theme'>
//             <div className='d-flex align-items-center mb-3'>
//               <i className='fa fa-info-circle fa-lg text-theme me-2'></i>
//               <h5 className='mb-0'>{t('ExtraInformation')}</h5>
//             </div>

//             {formik.values.extraInformationId === null && (
//               <ExtraInformationBuilderAdd
//                 FormColumnList={FormColumnList}
//                 setExtraInfoFormData={setExtraInfoFormData}
//                 ReferenceId={formik.values.id}
//               />
//             )}

//             {formik.values.extraInformationId !== null && (
//               <ExtraInformationBuilderUpdate
//                 extraInformationId={formik.values.extraInformationId}
//                 referenceId={formik.values.id}
//                 setExtraInfoFormData={setExtraInfoFormData}
//               />
//             )}

//             {/* {formik.values.extraInformationId && isUpdate ? (
//               <ExtraInformationBuilderUpdate
//                 extraInformationId={formik.values.extraInformationId}
//                 referenceId={formik.values.id}
//                 setExtraInfoFormData={setExtraInfoFormData}
//               />
//             ) : (
//               <ExtraInformationBuilderAdd
//                 FormColumnList={FormColumnList}
//                 setExtraInfoFormData={setExtraInfoFormData}
//                 ReferenceId={formik.values.id}
//               />
//             )} */}
//           </div>

//           <div className='text-center'>
//             <div className='d-flex justify-content-between gap-2'>
//               <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
//                 {formik.isSubmitting ? (
//                   <div className='spinner-border spinner-border-sm me-2'></div>
//                 ) : (
//                   <i className='fas fa-save fa-lg fa-fw me-2'></i>
//                 )}
//                 {t('Save')}
//               </button>
//               <button type='button' className='btn btn-lg  btn-default mb-1 w-100' data-bs-dismiss='modal'>
//                 <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//               </button>
//             </div>
//           </div>
//         </Form>
//       </Loading>
//     </>
//   );
// };

// export default AddDriver;

// import NtxPeoples2 from '../../../NTX/Peoples/NtxPeoples'
import Select from 'react-select';

import { Button, Form } from 'react-bootstrap';
// import NtxPeoples from '../../../NTX/Peoples/NtxPeoples3';
import { useFormik } from 'formik';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useTranslation } from 'react-i18next';
import {
  AddNtxPeoples,
  cleanPeoplesById,
  GetNtxPeoplesByID,
  GetNtxPeoplesList,
  UpdatNtxPeoples
} from '@store/NTX/Peoples/peoplesSlice';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetPersons from '@hooks/HR/use-get-persons';
import useGetFormColumn from '@hooks/Forms/use-get-FColumn';
import ExtraInformationBuilderAdd from '@pages/ExtraInformation/ExtraInformationBuilder/Add/ExtraInformationBuilderAdd';
import { useEffect, useState } from 'react';
import useAddUpdateExtraInformation from '@pages/ExtraInformation/ExtraInformationBuilder/useAddUpdateExtraInformation';
import ExtraInformationBuilderUpdate from '@pages/ExtraInformation/ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';
import Loading from '@components/Shared/Loader/Loading';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { GetDriversList } from '@store/FLEET/Equipments/equipmentsSlice';

type Props = {
  Id?: string | null;
  isUpdate?: boolean;
  onClose: () => void;
};

const AddDriver: React.FC<Props> = ({ Id, isUpdate = false, onClose }) => {
  const { HasPermission } = usePermissions();
  const [extraInfoFormData, setExtraInfoFormData] = useState<any>({});
  const [isEmployee, setIsEmployee] = useState<boolean>(true);

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { dataEmployees, loading: personLoading, error: personError } = useGetPersons();

  const { AddUpdateExtraInformation } = useAddUpdateExtraInformation();

  useEffect(() => {
    if (Id && isUpdate) {
      dispatch(GetNtxPeoplesByID(Id));
    }

    return () => {
      dispatch(cleanPeoplesById());
    };
  }, [Id, dispatch, isUpdate]);

  const { PeoplesById, loading: loading, error } = useAppSelector(state => state.Peoples);

  useEffect(() => {
    // عند التحميل للتعديل، تحقق إذا كان هناك personId لتعيين isEmployee
    if (PeoplesById?.personId) {
      setIsEmployee(true);
    }
  }, [PeoplesById]);

  const formik = useFormik({
    initialValues: {
      id: PeoplesById?.id ?? null,
      name: PeoplesById?.name ?? '',
      name2: PeoplesById?.name2 ?? '',
      personId: PeoplesById?.personId ?? null,
      typeCode: 'DRIVERS',
      email: PeoplesById?.email ?? '',
      phone: PeoplesById?.phone ?? '',
      mobile: PeoplesById?.mobile ?? '',
      address: PeoplesById?.address ?? '',
      customerNumber: PeoplesById?.customerNumber ?? '',
      extraInformationId: PeoplesById?.extraInformationId ?? null
    },
    enableReinitialize: true,
    // validationSchema: NtxPeopleSchema(t),

    onSubmit: async values => {
      // بناء الـ request body
      const requestBody: any = {
        id: values.id,
        name: values.name,
        name2: values.name2,
        personId: values.personId || null,
        email: values.email,
        phone: values.phone,
        mobile: values.mobile,
        address: values.address,
        typeCode: values.typeCode,
        customerNumber: values.customerNumber,
        parentId: null,
        extraInformationId: null, // سيتم تحديثه لاحقًا
        priceListId: null,
        shipToLocationId: null,
        billToLocationId: null,
        termsId: null,
        setOfBooksId: null,
        creditLimit: 0,
        paymentPriority: null,
        invoiceCurrencyCode: null,
        paymentCurrencyCode: null,
        invoiceLimit: null,
        paymentMethodLookupCode: '',
        bankAccountName: '',
        bankAccountNum: '',
        bankNumber: '',
        bankAccountType: '',
        vatCode: '',
        tradingName: '',
        workReference: '',
        companyRegistrationNumber: '',
        nationalInsuranceNumber: '',
        verificationNumber: '',
        description: '',
        peopleType: ''
      };

      let finalExtraInformationId = values.extraInformationId;

      // فقط إذا لم يكن موجودًا أو نحتاج لإنشاء واحد جديد
      if (values.extraInformationId === null) {
        if (FormColumnList?.columnList?.length > 0) {
          const newExtraInfoId = await AddUpdateExtraInformation(extraInfoFormData);
          if (newExtraInfoId === null) {
            CustomAlert({ action: 'Error', msg: 'حدث خطأ' });
            formik.setSubmitting(false);
            return;
          }
          finalExtraInformationId = newExtraInfoId;
        }
      } else {
        // حالة التحديث مع وجود extraInfo
        if (extraInfoFormData?.values?.length > 0) {
          const updatedExtraInfoId = await AddUpdateExtraInformation(extraInfoFormData);
          if (updatedExtraInfoId === null) {
            CustomAlert({ action: 'Error', msg: 'فشل في تحديث المعلومات الإضافية' });
            formik.setSubmitting(false);
            return;
          }
          finalExtraInformationId = updatedExtraInfoId;
        }
      }

      // دمج الـ extraInformationId في الطلب
      requestBody.extraInformationId = finalExtraInformationId;

      // تحديد الإجراء (إضافة أو تعديل)
      const actionToDispatch = isUpdate ? UpdatNtxPeoples(requestBody) : AddNtxPeoples(requestBody);

      // تنفيذ الإجراء
      dispatch(actionToDispatch)
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            if (isUpdate) {
              CustomAlert({ action: 'Edit' });
            } else {
              document.getElementById('closeModalForm')?.click();
              // formik.resetForm();
              CustomAlert({ action: 'Add' });
              dispatch(GetDriversList());
            }
            onClose();
            // dispatch(GetNtxPeoplesList('DRIVERS'));
          } else {
            CustomAlert({ action: 'Error', msg: res?.message || 'حدث خطأ غير معروف' });
          }
        })
        .catch(error => {
          console.error('Error in dispatch:', error);
          CustomAlert({ action: 'Error', msg: 'خطأ في الاتصال أو المعالجة' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  const {
    FormColumnList,
    loading: loading2,
    error: error2
  } = useGetFormColumn(
    !isUpdate || (isUpdate && formik.values.extraInformationId === null)
      ? '04ba71f9-c9b7-4e99-8a03-306a923b3cf0'
      : undefined
  );

  // const handleEmployeeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const isEmp = e.target.value === 'employee';
  //   setIsEmployee(isEmp);

  //   if (!isEmp) {
  //     // إذا لم يكن موظفًا، مسح personId
  //     formik.setFieldValue('personId', null);
  //   } else {
  //     // إذا كان موظفًا، مسح الحقول اليدوية
  //     formik.setFieldValue('name', '');
  //     formik.setFieldValue('name2', '');
  //   }
  // };

  const handleEmployeeSelect = (option: any) => {
    formik.setFieldValue('personId', option === null ? null : option.value);
    // formik.setFieldValue('customerNumber', option === null ? null : option.value);

    // عند اختيار موظف، تعيين الاسم تلقائيًا
    if (option) {
      formik.setFieldValue('name', option.label); // الاسم الإنجليزي
      formik.setFieldValue('name2', option.label); // يمكن تغيير هذا إذا كان لديك حقل للاسم العربي
      formik.setFieldValue('customerNumber', option.employeeNumber); // يمكن تغيير هذا إذا كان لديك حقل للاسم العربي
    }
  };

  // console.log(formik.values.customerNumber);

  //  console.log(dataEmployees);

  return (
    <>
      <Loading loading={personLoading || loading || loading2} error={personError || error || error2}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='mb-4'>
            <>
              <div className='row mb-4'>
                <div className='col-xl-12'>
                  <div className='form-group'>
                    <label className='form-label mb-3'>{t('DriverType')}</label>
                    <div className='d-flex gap-2'>
                      <Button
                        variant={isEmployee ? 'theme' : 'outline-theme'}
                        onClick={() => {
                          setIsEmployee(true);
                          formik.setFieldValue('name', '');
                          formik.setFieldValue('name2', '');
                          formik.setFieldValue('customerNumber', '');
                          formik.setFieldValue('personId', null);
                        }}
                        className='btn-sm py-2'
                        active={isEmployee}
                      >
                        <i className='fas fa-user-tie me-2'></i>
                        {t('EmployeeDriver')}
                      </Button>

                      <Button
                        variant={!isEmployee ? 'theme' : 'outline-theme'}
                        onClick={() => {
                          setIsEmployee(false);
                          formik.setFieldValue('name', '');
                          formik.setFieldValue('name2', '');
                          formik.setFieldValue('personId', null);
                        }}
                        className='btn-sm py-2'
                        active={!isEmployee}
                      >
                        <i className='fas fa-user-clock me-2'></i>
                        {t('ExternalDriver')}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row'>
                {isEmployee ? (
                  <>
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('EmployeeName')}</label>
                        <Select
                          classNamePrefix='react-select'
                          isLoading={personLoading}
                          isSearchable={true}
                          isClearable
                          name='personId'
                          options={dataEmployees}
                          onChange={handleEmployeeSelect}
                          value={
                            formik.values.personId
                              ? dataEmployees?.find((option: any) => option.value === formik.values.personId)
                              : null
                          }
                          placeholder={i18n.language === 'ar' ? 'إختر الموظف' : 'Select Employee'}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 })
                          }}
                          formatOptionLabel={option => (
                            <div className='d-flex justify-content-between   '>
                              <div className=''>
                                {option.hasVehicle && (
                                  <i className='fas fa-car text-theme me-2' title={t('AssignedVehicle')}></i>
                                )}
                                {option.label}
                              </div>
                              <div className='text-theme fw-bold'>{option.employeeNumber}</div>
                            </div>
                          )}
                          filterOption={({ label, data }, input) => {
                            const searchValue = input?.toLowerCase();
                            return (
                              label?.toLowerCase().includes(searchValue) ||
                              data.employeeNumber?.toLowerCase().includes(searchValue)
                            );
                          }}
                        />
                        {formik.errors.personId && formik.touched.personId && (
                          <div style={{ color: 'red' }}>{formik.errors.personId}</div>
                        )}
                      </div>
                    </div>
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('DriverName')}</label>
                        <Form.Control
                          className='form-control'
                          type='text'
                          autoComplete='off'
                          name='name'
                          value={formik.values.name}
                          disabled
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('LocalName')}</label>
                        <Form.Control
                          className='form-control'
                          type='text'
                          autoComplete='off'
                          name='name2'
                          onChange={formik.handleChange}
                          value={formik.values.name2}
                          isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                        />
                        <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
                      </div>
                    </div>
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('GlobalName')}</label>
                        <Form.Control
                          className='form-control'
                          type='text'
                          autoComplete='off'
                          name='name'
                          onChange={formik.handleChange}
                          value={formik.values.name}
                          isInvalid={!!(formik.touched.name && formik.errors.name)}
                        />
                        <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className='row'>
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Email')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='email'
                      onChange={formik.handleChange}
                      value={formik.values.email}
                      isInvalid={!!(formik.touched.email && formik.errors.email)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('MobileNumber')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='mobile'
                      onChange={formik.handleChange}
                      value={formik.values.mobile}
                      isInvalid={!!(formik.touched.mobile && formik.errors.mobile)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.mobile}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Address')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='address'
                      onChange={formik.handleChange}
                      value={formik.values.address}
                      isInvalid={!!(formik.touched.address && formik.errors.address)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.address}</Form.Control.Feedback>
                  </div>
                </div>
              </div>
            </>
          </div>

          <div className='rounded-2 p-3 mb-3 border border-theme'>
            <div className='d-flex align-items-center mb-3'>
              <i className='fa fa-info-circle fa-lg text-theme me-2'></i>
              <h5 className='mb-0'>{t('ExtraInformation')}</h5>
            </div>

            {formik.values.extraInformationId === null && (
              <ExtraInformationBuilderAdd
                FormColumnList={FormColumnList}
                setExtraInfoFormData={setExtraInfoFormData}
                ReferenceId={formik.values.id}
              />
            )}

            {formik.values.extraInformationId !== null && (
              <ExtraInformationBuilderUpdate
                extraInformationId={formik.values.extraInformationId}
                referenceId={formik.values.id}
                setExtraInfoFormData={setExtraInfoFormData}
              />
            )}
          </div>

          <div className='text-center'>
            <div className='d-flex justify-content-between gap-2'>
              <button
                hidden={!HasPermission('FleetEditDriver')}
                disabled={formik.isSubmitting}
                type='submit'
                className='btn btn-lg btn-theme mb-1 w-100'
              >
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-save fa-lg fa-fw me-2'></i>
                )}
                {t('Save')}
              </button>
              <button
                type='button'
                className='btn btn-lg  btn-default mb-1 w-100'
                data-bs-dismiss='modal'
                onClick={onClose}
              >
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default AddDriver;
